import React from "react";
import {
  User,
  Calendar,
  Folder,
  LogOut,
  Award,
  CheckCircle,
  MessageSquare,
  Book,
  FileUp,
  PlayCircle,
  Clock,
  LineChart,
  Users,
  DollarSign,
  Palette,
} from "lucide-react"; // Importing necessary icons from Lucide React, added Palette for customization
import Navbar from "../components/NavLite";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import BgImage from "../assets/newimages/newimage7.jpg";
import Nourivimg from "../assets/Services/Nouriv.png";
import Booking from "../assets/Services/Booking App Template.png";
import Waitlist from "../assets/Services/Waitlist App Template.png";

function Nouriv() {
<Helmet>
  <title>Nouriv Wellness Brand Website Design | Woaom Web Design</title>
  <meta
    name="description"
    content="Explore our custom web design for Nouriv — a modern wellness brand built with clean visuals, ecommerce functionality, and brand-first strategy. Serving women-led businesses in Dallas, Houston, Austin, Atlanta, New York City, and beyond."
  />
  <meta
    name="keywords"
    content="Nouriv wellness brand website, custom wellness website design Dallas TX, Houston wellness product ecommerce site, Austin TX web design for women wellness brands, Atlanta GA health and wellness brand websites, New York City supplement brand website design, Washington DC wellness ecommerce sites, Philadelphia PA custom wellness brand design, Memphis TN wellness product site design, Baton Rouge LA modern wellness branding, Shreveport LA holistic wellness websites, New Orleans health and wellness web design, Macon GA wellness product ecommerce websites, Augusta GA custom wellness brand sites, Baltimore wellness entrepreneur websites, supplement brand ecommerce website, holistic wellness brand identity design, responsive ecommerce wellness website, Shopify-style wellness brand design, women wellness brand website design, clean and calming wellness site design, ecommerce platform for health products, brand-first wellness website visuals, modern wellness entrepreneur site design, minimal and premium wellness brand website, wellness funnel design for women-owned businesses, healthy brand energy website design, product packaging website for wellness brands, luxury wellness ecommerce web design, digital presence for women wellness entrepreneurs"
  />
</Helmet>


  return (
    <div className="bg-white text-gray-900 font-inter ">
      {/* Hero Section */}
      <section
        className="relative bg-cover bg-center bg-no-repeat py-10 px-4 sm:px-6 lg:px-8 text-center shadow-lg "
        style={{
          backgroundImage: `url(${BgImage})`,
        }}
      >
        <Navbar />
        <div className="max-w-4xl mx-auto ">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight text-white mb-6">
            Introducing: The Woaom Web Design Client Dashboard Template
          </h1>
          <p className="text-xl sm:text-2xl text-white opacity-90 mb-8 max-w-2xl mx-auto">
            Elevate Your Coaching Experience & Streamline Client Success
          </p>
          <p className="text-md sm:text-lg text-white opacity-80 mb-10 max-w-3xl mx-auto">
            Are you a coach or consultant looking to streamline your client
            interactions, provide unparalleled value, and boost retention? The
            Woaom Web Design Client Dashboard Template is your all-in-one solution.
            Built by a fellow entrepreneur with{" "}
            <span className="font-semibold">React, Tailwind, and Firebase</span>
            , this custom-coded web application is designed to be the central
            hub for your clients, enhancing their journey and freeing up your
            valuable time.
          </p>
          <a
            href="https://woaomtemplateone.web.app" // Link to your contact or consultation booking page
            className="inline-flex items-center text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black"
          >
            View App →
          </a>
        </div>
      </section>

      {/* Product Summary */}
      <section className="bg-white py-16 px-6">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div>
            <img
              src={Nourivimg}
              alt="Nouriv Dashboard Preview"
              className="shadow-lg"
            />
          </div>
          <div>
            <h2 className="text-2xl font-semibold mb-4">
              Nouriv Coaching Dashboard
            </h2>
            <p className="text-gray-700 mb-4">
              Built for transformational coaches & wellness pros ready to create
              premium client experiences without overwhelm.
            </p>
            <p className="text-lg font-bold text-[#2E2D2B] mb-2">$199.99</p>
            <a
              href="https://buy.stripe.com/aFa00k5H7eQzf5P9m94sE03"
              className="inline-block text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black"
              target="_blank"
              rel="noopener noreferrer"
            >
              Buy This App →
            </a>
          </div>
        </div>
      </section>

      {/* Feature List */}
      <section className="py-12 px-6 bg-gray-50">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-2xl font-semibold mb-6">
            {" "}
            TAKE A PEEK inside the NOURIV TEMPLATE
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 text-left text-gray-700 text-sm">
            <ul className="space-y-2 list-disc list-inside">
              <li>Welcome Dashboard</li>
              <li>Upcoming Sessions</li>
              <li>Resource Library</li>
              <li>Progress Tracker</li>
            </ul>
            <ul className="space-y-2 list-disc list-inside">
              <li>Upload Homework</li>
              <li>Messaging System</li>
              <li>Zoom Replay Embeds</li>
              <li>Session Notes Archive</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Longform Description */}
      <section className="py-12 px-6 bg-white">
        <div className="max-w-4xl mx-auto prose prose-lg prose-gray">
          <p>
            The Nouriv Coaching Platform is a fully branded, client-first
            dashboard built with React and Firebase. From custom greetings to
            Zoom replays and file uploads, it’s designed to increase retention
            and save you time.
          </p>
          <p>
            Whether you're running 1:1 coaching, group programs, or digital
            products, Nouriv adapts to your workflow and branding — creating a
            seamless client experience that looks and feels like you.
          </p>
        </div>
      </section>

      {/* Related Products */}
      <section className="py-12 px-6 bg-gray-100">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-xl font-semibold mb-4">You may also like…</h2>
          <div className="grid sm:grid-cols-3 gap-6">
            <a href="/bookingapp">
              <div className="bg-white border text-center rounded-lg shadow-sm">
                <img src={Booking} alt="Booking Site" className="mb-4" />
                <h3 className="font-semibold">Booking Site Template App</h3>
                <p className="text-[#2E2D2B] font-medium">$199.00</p>
              </div>
            </a>
            <a href="/waitlistapp">
              <div className="bg-white border text-center rounded-lg shadow-sm">
                <img src={Waitlist} alt="Waitlist Funnel" className="mb-4" />
                <h3 className="font-semibold">Waitlist Funnel Template App</h3>
                <p className="text-[#2E2D2B] font-medium">$97.00</p>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-16 bg-[#F8F8F8] px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl font-semibold text-center mb-10">
            How It Works
          </h2>
          <ol className="space-y-6 text-gray-700 text-sm">
            <li>
              <strong>Step 1:</strong> Book your free discovery call
            </li>
            <li>
              <strong>Step 2:</strong> Choose your features & add-ons
            </li>
            <li>
              <strong>Step 3:</strong> Get a detailed proposal & agreement
            </li>
            <li>
              <strong>Step 4:</strong> We'll code & customize your app
            </li>
            <li>
              <strong>Step 5:</strong> Go live & onboard your clients{" "}
            </li>
          </ol>
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-white py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl font-semibold text-center mb-8">
            Frequently Asked Questions
          </h2>
          <div className="border-b py-4">
            <h3 className="text-lg font-medium">
              Can I use this if I’m not tech-savvy?
            </h3>
            <p className="text-sm mt-2 text-gray-600">
              Yes! You’ll receive a video walkthrough and full setup support.
            </p>
          </div>
          <div className="border-b py-4">
            <h3 className="text-lg font-medium">Is it mobile-friendly?</h3>
            <p className="text-sm mt-2 text-gray-600">
              Yes, it works beautifully on desktop, tablet, and mobile.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section
        id="get-app"
        className="py-16 px-4 sm:px-6 lg:px-8 text-center bg-gray-50 rounded-b-3xl shadow-lg"
      >
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
            Ready to Transform Your Client Experience?
          </h2>
          <p className="text-lg text-gray-700 mb-10">
            Book a free discovery call to get your own customized Nouriv Client
            Dashboard today.
          </p>
          <a
            href="/contact"
            className="inline-flex items-center text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black"
          >
            Book a Call →
          </a>
        </div>
      </section>
      <Footer />
    </div>
  );
}

// Export the Nouriv component as default
export default Nouriv;
